<template>
  <div>
    <page-header title="个人设置" />

    <div class="setting-container">
      <div class="item-container" @click="handleNavigationClick('personal-info')">
        <div class="list-item">
          <div>个人资料</div>
          <img src="../../../assets/into_icon@3x.png" />
        </div>
      </div>
      <div class="item-container" @click="handleNavigationClick('address-list')">
        <div class="list-item">
          <div>收货地址</div>
          <img src="../../../assets/into_icon@3x.png" />
        </div>
      </div>
      <div class="item-container">
        <div class="list-item">
          <div>清除缓存</div>
          <img src="../../../assets/into_icon@3x.png" />
        </div>
      </div>
      <div class="item-container" @click="handleNavigationClick('about-us')">
        <div class="list-item">
          <div>关于我们</div>
          <img src="../../../assets/into_icon@3x.png" />
        </div>
      </div>
    </div>
    <div class="primary-button" @click="logout">退出账号</div>
  </div>
</template>

<script>
import PageHeader from '@/components/header.vue';
import { mapMutations } from 'vuex';
export default {
  data() {
    return {};
  },

  created() {},

  methods: {
    ...mapMutations(['setToken', 'setUserInfo']),
    handleNavigationClick(name) {
      this.$router.push({
        name,
      });
    },

    logout() {
      this.setToken('');
      this.setUserInfo({});
      this.$router.back();
    },
  },
  components: {
    PageHeader,
  },
};
</script>
<style scoped lang="sass" src="./index.sass"></style>
